import AbstractSessionModel from './AbstractSessionModel';
import Observable from '../decorators/Observable';
import StoreFieldInSession from '../decorators/StoreFieldInSession';
import Action from '../decorators/Action';

export default class FormModel extends AbstractSessionModel {
  @StoreFieldInSession({
    lateKeyInitilization: true
  })
  @Observable()
  public formName: string = '';

  @StoreFieldInSession({
    lateKeyInitilization: true
  })
  @Observable()
  public formValues: any = {};

  constructor(formName: string) {
    super();
    this.formName = formName;

    super.initFields();
  }

  @Action()
  public updateFormData(values: any) {
    this.formValues = values;
  }

  public getSessionKey() {
    return this.formName + '_FORM';
  }
}
